import { Injectable } from '@angular/core';
import { initAll } from 'govuk-frontend';

@Injectable({
  providedIn: 'root',
})
export class GovukInitService {
  constructor() {}

  init() {
    try {
      initAll();
    } catch (err) {
      console.log(err);
    }
  }
}
